export default __webpack_public_path__ + "static/media/phone-solid.332eaf50.svg";